module.exports = __webpack_public_path__ + "static/00093.21971fed.jpg";